import { render, staticRenderFns } from "./ConceptSlide.vue?vue&type=template&id=a07d052c&scoped=true&"
import script from "./ConceptSlide.vue?vue&type=script&lang=js&"
export * from "./ConceptSlide.vue?vue&type=script&lang=js&"
import style0 from "./ConceptSlide.vue?vue&type=style&index=0&id=a07d052c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07d052c",
  null
  
)

export default component.exports